module.exports = __webpack_public_path__ + "static/img_dxsm2.b8de6608.png";